import {
  FETCH_BEGIN_CHALLENGE_TEAM_DETAIL,
  FETCH_BEGIN_CHALLENGE_TEAM_SUCCESS,
  FETCH_BEGIN_CHALLENGE_TEAM_FAILURE,
  FETCH_BEGIN_USER_DETAIL_SUCCESS,
  FETCH_BEGIN_USER_DETAIL_FAILURE
} from './types';
import { fetchBeginTeamDashboardDetail, fetchBeginUserDetail } from '../services/challenge/beginTeamDashboard.service';

export const fetchBeginChallengeTeamDetail = (params, challengeData = null) => (dispatch) => {
  dispatch({ type: FETCH_BEGIN_CHALLENGE_TEAM_DETAIL });

  return fetchBeginTeamDashboardDetail(params, challengeData)
    .then((result) => {
      dispatch({
        type: FETCH_BEGIN_CHALLENGE_TEAM_SUCCESS,
        payload: result,
        error: false
      });
      return result;
    })
    .catch(function (error) {
      dispatch({ type: FETCH_BEGIN_CHALLENGE_TEAM_FAILURE, payload: error.message });
    });
};

export const fetchBeginUserDetailsData = (params) => (dispatch) =>
  fetchBeginUserDetail(params).then((result) => {
    dispatch({
      type: FETCH_BEGIN_USER_DETAIL_SUCCESS,
      payload: result,
      hasError: false
    });
  }).catch(function (error) {
    dispatch({ type: FETCH_BEGIN_USER_DETAIL_FAILURE, payload: error.message });
  });